import React, {useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import AdminUserForm from "../../../components/users/AdminUserForm";
import {useGetUserQuery, useUpdateUserMutation} from "../../../api/userApiSlice";

function EditUser(props) {
  const history = useHistory();
  const {userId} = useParams();
  const {data: user = {}, isSuccess} = useGetUserQuery(userId)
  const { t } = useTranslation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const [updateUser] = useUpdateUserMutation();

  const goToUser = (data) => history.push(`/users/${userId}`)

  const handleSubmit = (data) => {
    updateUser({user: {...data, userId}}).unwrap()
      .then(goToUser)
      .catch(error => {})
  }

  const handleCancel = () => goToUser()

  return (
    <>
      <Title
        main={t("menu.users")}
        sub={`${user.firstName} ${user.lastName}`}
        group={false}
        onBack={()=>{history.goBack()}}>
        <FormButton submit {...submitButtonProps}/>
        <FormButton cancel onClick={handleCancel}/>
      </Title>
      <AdminUserForm user={user} handleSubmit={handleSubmit} setSubmitButtonProps={setSubmitButtonProps} />
    </>
  )
}

export default EditUser
